export default __webpack_public_path__ + "static/char-s-07-en-a2a3ca8c2ab0c22b318f18c834b6fefb.png";